import { css, styled } from 'canoe';
import { Form } from 'formik';

export const StyledForm = styled(Form)`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: ${theme.spaces.xs};
  `}
`;

export const FieldWrapper = styled.div<{ maxWidth?: number }>`
  ${({ maxWidth }) => css`
    flex: 1 1 0;
    max-width: ${typeof maxWidth !== 'undefined' ? `${maxWidth}px` : '330px'};
    display: flex;
  `}
`;
export const FieldWithErrors = styled.div`
  width: 100%;
`;
